import React from 'react';
import Card from '../shared/Card';

const LoginCard = ({ children }) => {
  return (
    <div className="login-container">
      <Card className="login-card">
        <header className="login-header">
          <h1>🧠 SWT AI Tool</h1>
          <p>Sign in to access your reports and analysis</p>
        </header>
        
        <div className="login-content">
          {children}
        </div>
      </Card>
    </div>
  );
};

export default LoginCard;
